<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div id="overlay">
            <div class="loader"></div>
          </div>
          <div slot="header">
            <b-row>
            <b-col>
            <router-link 
							class="btn-md ml-5 float-left d-block"
							:to="{path:'/newplanlisting'}" target="_blank">Daily Plan Master
							
						</router-link>
            </b-col>
              <b-col><strong>National Line Haul Dashboard</strong></b-col>


            </b-row>
          </div>
          
          <!-- North to South Section -->
          <b-row class="module north-to-south">
            <b-col>
               <h5 @click="toggleCollapse('northToSouth')" class="collapsible-header">
                North to South ({{ totalRecordsNorthToSouth }})
                <b-button size="sm" variant="link">
                  <i :class="isNorthToSouthCollapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                </b-button>
              </h5>
              <b-collapse v-model="isNorthToSouthCollapsed">
                <div class="table-container">
                  <table v-if="northToSouthData.length > 0" class="table table-striped table-hover" >
                    <thead>
                      <tr>
                        <th>Action</th> 
                        <th v-for="(header, index) in tableHeadersNorthToSouth" :key="'header-' + index">
                          {{ formatHeader(header) }}
                        </th>
                        <th>Download</th>
                      </tr>
                    </thead>
                    <tbody v-for="(row, index) in northToSouthData" :key="'north-' + index">                  
                      <tr>
                        <td>
                          <b-button 
                            
                            size="sm"
                            variant="info" 
                            @click="NationalLineHaulshowModal(row)"
                          >
                            {{ row.expanded ? '-' : '+' }}                          
                          </b-button>
                          <div  class="plan-id">
                            <small>Plan ID: {{ row.planid }}</small>
                          </div>
                        
                        </td>
                        <td v-for="(header, i) in tableHeadersNorthToSouth" :key="'row-' + index + '-' + i">           
                              <template v-if="header.startsWith('destination')">
                                    <template v-if="row.destinations.length > 0 && row.destinations[parseInt(header.replace('destination', '')) - 1] && row.destinations[parseInt(header.replace('destination', '')) - 1][header]">
                                      {{ row.destinations[parseInt(header.replace('destination', '')) - 1][header] }}
                                    </template>
                                    <template v-else>
                                      <!-- Optional: Display a default message if the value does not exist -->
                                      N/A
                                    </template>
                                  </template>
                                  <template v-else-if="header.startsWith('arrivaldatetime')">
                                    <template v-if="row.destinations.length > 0 && row.destinations[parseInt(header.replace('arrivaldatetime', '')) - 1] && row.destinations[parseInt(header.replace('arrivaldatetime', '')) - 1][header]">
                                      {{ row.destinations[parseInt(header.replace('arrivaldatetime', '')) - 1][header] }}
                                    </template>
                                    <template v-else>
                                      N/A
                                    </template>
                                  </template>
                                  <template v-else-if="header.startsWith('departuredatetime')">
                                    <template v-if="row.destinations.length > 0 && row.destinations[parseInt(header.replace('departuredatetime', '')) - 1] && row.destinations[parseInt(header.replace('departuredatetime', '')) - 1][header]">
                                      {{ row.destinations[parseInt(header.replace('departuredatetime', '')) - 1][header] }}
                                    </template>
                                    <template v-else>
                                      N/A
                                    </template>
                                  </template>
                                  <template v-else>
                                    {{ header === 'Plan Status' ? row.planstatus : row[header] }}
                                  </template>
                          </td>
                                  
                                    
                          <td>
                                  <b-button size="sm" class="mr-2" @click="downloadAdhocFile(row.planid)">
                                    <i class="fas fa-download"></i>
                                  </b-button>
                        </td>
                      </tr>
                    
                    </tbody>                  
                  </table>
                  <table v-else >
                      <thead>
                        <tr>
                        <th>Action</th> 
                        <th v-for="(header, index) in tableHeadersNorthToSouth" :key="'header-' + index">
                          {{ formatHeader(header) }}
                        </th>
                        <th>Download</th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td :colspan="tableHeadersNorthToSouth.length + 3" class="text-center">
                          <b-spinner v-if="loading" class="spinner" label="Loading..."></b-spinner>
                          <span v-else>No records found.</span>
                          </td>
                        </tr>
                      </tbody>  
                    </tbody>
                  </table>  
                </div>   
              </b-collapse>             
            </b-col>
          </b-row>   

          <!-- South to North Section -->
          <b-row class="module south-to-north">
            <b-col>
              <h5 @click="toggleCollapse('southToNorth')" class="collapsible-header">
                South to North ({{ totalRecordsSouthToNorth }})
                <b-button size="sm" variant="link">
                  <i :class="isSouthToNorthCollapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                </b-button>
              </h5>
              <b-collapse v-model="isSouthToNorthCollapsed">
                <div class="table-container">
                  <table v-if="southToNorthData.length > 0" class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Action</th> 
                        <th v-for="(header, index) in tableHeadersSouthToNorth" :key="'header-' + index">
                          {{ formatHeader(header) }}
                        </th>
                        <th>Download</th>
                      </tr>
                    </thead>
                    <tbody v-for="(row, index) in southToNorthData" :key="'south-' + index">
                      <tr>
                        <td>
                          <b-button 
                            @click="NationalLineHaulshowModal(row)"
                            size="sm"
                            variant="info" 
                          >
                            {{ row.expanded ? '-' : '+' }}
                          </b-button>
                          <div  class="plan-id">
                            <small>Plan ID: {{ row.planid }}</small>
                          </div>
                          
                        </td>
                        <td v-for="(header, i) in tableHeadersSouthToNorth" :key="'row-' + index + '-' + i">           
                              <template v-if="header.startsWith('destination')">
                                <template v-if="row.destinations.length > 0 && row.destinations[parseInt(header.replace('destination', '')) - 1] && row.destinations[parseInt(header.replace('destination', '')) - 1][header]">
                                  {{ row.destinations[parseInt(header.replace('destination', '')) - 1][header] }}
                                </template>
                                <template v-else>
                                  <!-- Optional: Display a default message if the value does not exist -->
                                  N/A
                                </template>
                              </template>
                              <template v-else-if="header.startsWith('arrivaldatetime')">
                                <template v-if="row.destinations.length > 0 && row.destinations[parseInt(header.replace('arrivaldatetime', '')) - 1] && row.destinations[parseInt(header.replace('arrivaldatetime', '')) - 1][header]">
                                  {{ row.destinations[parseInt(header.replace('arrivaldatetime', '')) - 1][header] }}
                                </template>
                                <template v-else>
                                  N/A
                                </template>
                              </template>
                              <template v-else-if="header.startsWith('departuredatetime')">
                                <template v-if="row.destinations.length > 0 && row.destinations[parseInt(header.replace('departuredatetime', '')) - 1] && row.destinations[parseInt(header.replace('departuredatetime', '')) - 1][header]">
                                  {{ row.destinations[parseInt(header.replace('departuredatetime', '')) - 1][header] }}
                                </template>
                                <template v-else>
                                  N/A
                                </template>
                              </template>
                              <template v-else>
                                    {{ header === 'Plan Status' ? row.planstatus : row[header] }}
                              </template>
                        </td>  
                        <td>
                                  <b-button size="sm" class="mr-2" @click="downloadAdhocFile(row.planid)">
                                    <i class="fas fa-download"></i>
                                  </b-button>
                        </td>
                      </tr>
                    
                    </tbody>
                  </table>
                  <table v-else >
                      <thead>
                        <tr>
                        <th>Action</th> 
                        <th v-for="(header, index) in tableHeadersSouthToNorth" :key="'header-' + index">
                          {{ formatHeader(header) }}
                        </th>
                        <th>Download</th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td :colspan="tableHeadersSouthToNorth.length + 3" class="text-center">
                            <b-spinner v-if="loading" class="spinner" label="Loading..."></b-spinner>
                            <span v-else>No records found.</span>                       
                          </td>
                        </tr>
                      </tbody>  
                    </tbody>
                  </table>
                </div>
              </b-collapse>  
            </b-col>
          </b-row>
          <!-- P2P Section -->
          <b-row class="module p2p">
            <b-col>
             <h5 @click="toggleCollapse('p2p')" class="collapsible-header">
              P2P ({{ totalRecordsP2P }})
              <b-button size="sm" variant="link">
                <i :class="isP2PCollapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
              </b-button>
            </h5>
            <b-collapse v-model="isP2PCollapsed">
              <div class="table-container">
                <table v-if="p2pData.length > 0" class="table table-striped table-hover">
                   <thead>
                    <tr>
                      <th>Action</th> 
                      <th v-for="(header, index) in tableHeadersP2P" :key="'header-' + index">
                        {{ formatHeader(header) }}
                      </th>
                      <th>Download</th>
                    </tr>
                  </thead>
                  <tbody v-for="(row, index) in p2pData" :key="'p2p-' + index">
                    <tr>
                      <td>
                        <b-button 
                           @click="NationalLineHaulshowModal(row)"
                          size="sm"
                          variant="info"
                        >
                          {{ row.expanded ? '-' : '+' }}
                        </b-button>
                        <div  class="plan-id">
                          <small>Plan ID: {{ row.planid }}</small>
                        </div>
                       
                      </td>
                      <td v-for="(header, i) in tableHeadersP2P" :key="'row-' + index + '-' + i">           
                            <template v-if="header.startsWith('destination')">
                              <template v-if="row.destinations.length > 0 && row.destinations[parseInt(header.replace('destination', '')) - 1] && row.destinations[parseInt(header.replace('destination', '')) - 1][header]">
                                {{ row.destinations[parseInt(header.replace('destination', '')) - 1][header] }}
                              </template>
                              <template v-else>
                                <!-- Optional: Display a default message if the value does not exist -->
                                N/A
                              </template>
                            </template>
                            <template v-else-if="header.startsWith('arrivaldatetime')">
                              <template v-if="row.destinations.length > 0 && row.destinations[parseInt(header.replace('arrivaldatetime', '')) - 1] && row.destinations[parseInt(header.replace('arrivaldatetime', '')) - 1][header]">
                                {{ row.destinations[parseInt(header.replace('arrivaldatetime', '')) - 1][header] }}
                              </template>
                              <template v-else>
                                N/A
                              </template>
                            </template>
                            <template v-else-if="header.startsWith('departuredatetime')">
                              <template v-if="row.destinations.length > 0 && row.destinations[parseInt(header.replace('departuredatetime', '')) - 1] && row.destinations[parseInt(header.replace('departuredatetime', '')) - 1][header]">
                                {{ row.destinations[parseInt(header.replace('departuredatetime', '')) - 1][header] }}
                              </template>
                              <template v-else>
                                N/A
                              </template>
                            </template>
                            <template v-else>
                                    {{ header === 'Plan Status' ? row.planstatus : row[header] }}
                            </template>
                      </td>  
                      <td>
																<b-button size="sm" class="mr-2" @click="downloadAdhocFile(row.planid)">
																	<i class="fas fa-download"></i>
																</b-button>
                      </td>
                    </tr>
                   
                  </tbody>
                </table>
                <table v-else >
                    <thead>
                      <tr>
                      <th>Action</th> 
                      <th v-for="(header, index) in tableHeadersP2P" :key="'header-' + index">
                        {{ formatHeader(header) }}
                      </th>
                      <th>Download</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td :colspan="tableHeadersP2P.length + 3" class="text-center">
                          <b-spinner v-if="loading" class="spinner" label="Loading..."></b-spinner>
                          <span v-else>No records found.</span>
                        </td>
                      </tr>
                    </tbody>  
                  </tbody>
                </table>
              </div>  
            </b-collapse>
            </b-col>
          </b-row>

        </b-card>
      </b-col>
    </b-row>

  

    <b-modal ref="viewPlanDetails-modal" size="xl" hide-footer title="View Plan Details">
        <div class="d-block text-left float-left">
           <b-button class="editwhitebtn font-weight-bold d-inline-block" @click="redirectToEditPlan(editplanid)" >Edit
            Plan</b-button>
          <router-link class="editgreybtn d-inline-block ml-5" :to="{path:''}">Total Loading time:
            {{totalloadtime}}Hrs
          </router-link>
        </div>
        <div class="d-block float-right">
          <b>Total Records: </b> <b class="text-danger"> {{totalrecords}}</b>
        </div>
        <div class="clearfix"></div>
        <b-card-body class="p-0" style="overflow: auto;">
          <div class="table-responsive">
            <b-table class="mt-3" show-empty stacked="md" :busy="isBusy" :items="ddplandetaildata"
              :fields="ddplandetailfields" :current-page="currentPage" :per-page="perPage" :filter="filter"
              :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
              @filtered="onFiltered" :bordered="bordered">

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>

              <template slot="planningorigin" slot-scope="row">
                <span>{{row.item.planningorigin || 'NA'}}</span>
              </template>

              <template slot="planningdate" slot-scope="row">
                <span>{{row.item.planningdate || 'NA'}}</span>
              </template>

              <template slot="loadid" slot-scope="row">
                <span>{{row.item.loadid || 'NA'}}</span>
              </template>

              <template slot="plandate" slot-scope="row">
                <span>{{row.item.planningdate || 'NA'}}</span>
              </template>

              <template slot="whorhub" slot-scope="row">
                <span>{{row.item.whorhub || 'NA'}}</span>
              </template>

              <template slot="noofboxes" slot-scope="row">
                <span>{{row.item.noofboxes || 'NA'}}</span>
              </template>

              <template slot="shippingreferenceno" slot-scope="row">
                <span>{{row.item.shippingreferenceno || 'NA'}}</span>
              </template>

              <template slot="userid" slot-scope="row">
                <span>{{row.item.userid || 'NA'}}</span>
              </template>

              <template slot="companyname" slot-scope="row">
                <span>{{row.item.companyname || 'NA'}}</span>
              </template>

              <template slot="dest_city" slot-scope="row">
                <span>{{row.item.dest_city || 'NA'}}</span>
              </template>

              <template slot="warehouseorhubname" slot-scope="row">
                <span>{{row.item.warehouseorhubname || 'NA'}}</span>
              </template>

              <template slot="loadpotype" slot-scope="row">
                <span>{{row.item.loadpotype || 'NA'}}</span>
              </template>

              <template slot="shipmentvolumetricweight" slot-scope="row">
                <span>{{row.item.shipmentvolumetricweight || 'NA'}}</span>
              </template>

              <template slot="shippincode" slot-scope="row">
                <span>{{row.item.shippincode || 'NA'}}</span>
              </template>
              <template slot="unloadingsequence" slot-scope="row">
                <span>{{row.item.unloadingsequence || 'NA'}}</span>
              </template>

              <template slot="vehicleno" slot-scope="row">
                <span>{{row.item.vehicleno || 'NA'}}</span>
              </template>
              <template slot="transportername" slot-scope="row">
                <span>{{row.item.transportername || 'NA'}}</span>
              </template>
              <template slot="isregularadhoc" slot-scope="row">
                <span>{{row.item.isregularadhoc || 'NA'}}</span>
              </template>
              <template slot="trip" slot-scope="row">
                <span>{{row.item.trip || 'NA'}}</span>
              </template>
              <template slot="remark" slot-scope="row">
                <span>{{row.item.remark || 'NA'}}</span>
              </template>
            </b-table>
          </div>
        </b-card-body>
    </b-modal>

    <!-- Plan Type National Line Haul Dashboard Modal -->
    <b-modal ref="NationalLineHaul-modal" size="xl" hide-footer title="National Line Haul Dashboard">     
      <div class="d-block text-left mt-3">
        <!-- <b-button size="sm">Edit Plan</b-button> -->
        <div>
          
           <b-button class="editwhitebtn font-weight-bold d-inline-block" @click="redirectToEditPlan(editplanid)" >Edit
            Plan</b-button>

          <button class="editwhitebtn font-weight-bold d-inline-block ml-3"
            @click="viewPlanDetailsModal(editplanid,'hidehours')">View Plan
            Details
          </button>
        </div>
        <!-- <b-button size="sm" class="ml-5 editgreybtn">Total Loading time: {{totalloadtime}}Hrs</b-button> -->
      </div>
      <b-card-body class="p-0" style="overflow: auto;">
        <div class="table-responsive">
          <table id="planTable">
            <thead style="background: #ECEFF1 !important;">
              <tr id="headerRow">
                <th rowspan="2">Origin Hub</th>
                <th colspan="3" id="totalPlanLoadedHeader" class="text-center">Total Loads Planned</th>
                <!-- Dynamic columns under Total Plan Loaded -->
                <th rowspan="2">Total No. of Boxes</th>
                <th rowspan="2">Volumetric WT</th>
                <th rowspan="2">Physical WT</th>
                <th rowspan="2">Loads Dispatched</th>
                <th rowspan="2">Loads Hubinscan</th>
                <th rowspan="2">Damage Box</th>
                <th rowspan="2">Shortage</th>
                <th rowspan="2">Excess</th>
                <th rowspan="2">Vehicle Release Time</th>
              </tr>
              <tr id="hubloadHeaderRow">
                <!-- Dynamic hubload keys will go here -->
                <th>Total</th>
              </tr>
            </thead>
            <tbody id="planData">
              <!-- Data rows will be appended here -->
            </tbody>
            <tfoot id="totalRow">
              <!-- Total row will be appended here -->
            </tfoot>
          </table>
        </div>
      </b-card-body>
      <b-card-body class="p-0" style="overflow: auto;">
        <div class="table-responsive">

          <b-table class="mt-3" show-empty stacked="md" :busy="isBusy" :items="lhhubloadunload"
            :fields="hubzone" :current-page="currentPage" :per-page="perPage" :filter="filter"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
            @filtered="onFiltered" :bordered="bordered">

            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>

            <template slot="hubname" slot-scope="row">
              <span>{{row.item.hubname || 'NA'}}</span>
            </template>

            <template slot="loadingtime" slot-scope="row">
              <span v-if="row.item.loadingtime">{{row.item.loadingtime}} hrs</span>
              <span v-else>NA</span>
            </template>

            <template slot="unloadingtime" slot-scope="row">
              <span v-if="row.item.unloadingtime">{{row.item.unloadingtime}} hrs</span>
              <span v-else>NA</span>
            </template>

            <template slot="zoningtime" slot-scope="row">
              <span v-if="row.item.zoningtime">{{row.item.zoningtime}} hrs</span>
              <span v-else>NA</span>
            </template>
          </b-table>
        </div>
      </b-card-body>
    </b-modal>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Swal from 'sweetalert2';
import Vue from 'vue'
export default {
  data() {
    return {
        items: [],
        errors: {}, // Object to hold validation errors      
        northToSouthData: [],
        southToNorthData: [],
        p2pData: [],
        moduleType:null,
        file: "",
        totalrecords: '',
        plandetaildata: [], 
        editplanid:"",
        ddplandetaildata: [],
        lhhubloadunload:[],
        ddplandetailfields: [{
            key: "planningorigin",
            label: "Planning Origin",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "planningdate",
            label: "Planning Date",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "loadid",
            label: "Load ID",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "whorhub",
            label: "WH/HUB",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "noofboxes",
            label: "No. Of Boxes",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "shippingreferenceno",
            label: "Shipping Ref. No.",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "userid",
            label: "User ID",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "companyname",
            label: "Company Name",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "dest_city",
            label: "Dest_City",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "warehouseorhubname",
            label: "warehousename / Hub zone",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "loadpotype",
            label: "loadpotype",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "shipmentvolumetricweight",
            label: "shipmentvolumetric weight",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "shippincode",
            label: "shippincode",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "unloadingsequence",
            label: "unloading sequence",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "vehicleno",
            label: "vehicleno",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "transportername",
            label: "transporter name",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "isregularadhoc",
            label: "isregularadhoc",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "trip",
            label: "trip",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "remark",
            label: "remark",
            sortable: true,
            sortDirection: "desc",
          }
          ],
        planDetails: [],
        isBusy: false,
        lhplandetaildata: [],        
        dynamicFields: [],
				hubzone: [
          {
            key: "hubname",
            label: "Hub Name",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "loadingtime",
            label: "Loading Time",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "unloadingtime",
            label: "Unloading Time",
            sortable: true,
            sortDirection: "desc",
          }, {
            key: "zoningtime",
            label: "Zoning time",
            sortable: true,
            sortDirection: "desc",
          }
        ],
		
        showPlanModal: false, // Controls the visibility of the modal
        hubOptions: [
          { value: null, text: 'Select Hub' },       
        ],
        totalRecordsP2P:0,
        totalRecordsNorthToSouth:0,
        totalRecordsSouthToNorth:0,
        loadingdetails:false,
        adhocPlanCsvUrl: '',
        isNorthToSouthCollapsed: true, // Default expanded
        isSouthToNorthCollapsed: true, // Default expanded
        isP2PCollapsed: true, // Default expanded
    };
  },
  computed: {
    tableHeadersNorthToSouth() {
      // Base headers
      const baseHeaders = [
        'vehicleplacementdate',
        'vehicleno',
        'transportername',
        'origin',
        'dispatchdatetime'        
      ];
      const destinationHeaders = [];
      const maxDestinations = Math.max(
        ...this.northToSouthData.map((row) => row.destinations.length)
      );
      for (let i = 1; i <= maxDestinations; i++) {
        destinationHeaders.push(`destination${i}`, `arrivaldatetime${i}`, `departuredatetime${i}`);
      }
        const planStatusHeader = 'Plan Status';

      return [...baseHeaders, ...destinationHeaders, planStatusHeader];
    },
    tableHeadersSouthToNorth() {
      // Base headers
      const baseHeaders = [
        'vehicleplacementdate',
        'vehicleno',
        'transportername',
        'origin',
        'dispatchdatetime'        
      ];
      const destinationHeaders = [];
      const maxDestinations = Math.max(
        ...this.southToNorthData.map((row) => row.destinations.length)
      );
      for (let i = 1; i <= maxDestinations; i++) {
        destinationHeaders.push(`destination${i}`, `arrivaldatetime${i}`, `departuredatetime${i}`);
      }
      const planStatusHeader = 'Plan Status';
      return [...baseHeaders, ...destinationHeaders, planStatusHeader];
    },
    tableHeadersP2P() {
      // Base headers
      const baseHeaders = [
        'vehicleplacementdate',
        'vehicleno',
        'transportername',
        'origin',
        'dispatchdatetime'        
      ];
      const destinationHeaders = [];
      const maxDestinations = Math.max(
        ...this.p2pData.map((row) => row.destinations.length)
      );
      for (let i = 1; i <= maxDestinations; i++) {
        destinationHeaders.push(`destination${i}`, `arrivaldatetime${i}`, `departuredatetime${i}`);
      }
      const planStatusHeader = 'Plan Status';
      return [...baseHeaders, ...destinationHeaders, planStatusHeader];
     }
  },
  created: function () {
			var userdata = localStorage.getItem("userData");
			var userInfo = JSON.parse(userdata);
			this.userType = userInfo.user_type;
			this.uploadedby = userInfo.sysemailid;
			this.user_id = userInfo.sysusermasterid;
			this.accessBody = userInfo.body;
			//console.log("--------->>>>>>>>>>", userInfo.body)
			this.getNationalHugLineDashboard();			
	},
  methods: {
        toggleCollapse(section) {
          if (section === 'northToSouth') {
            this.isNorthToSouthCollapsed = !this.isNorthToSouthCollapsed;
          } else if (section === 'southToNorth') {
            this.isSouthToNorthCollapsed = !this.isSouthToNorthCollapsed;
          } else if (section === 'p2p') {
            this.isP2PCollapsed = !this.isP2PCollapsed;
          }
        },
       getplandetaildata(data) {
            // Clear old data from the table
            const tableBody = document.getElementById('planData');
            const totalRow = document.getElementById('totalRow');
            tableBody.innerHTML = ''; // Clear the table body
            totalRow.innerHTML = '';  // Clear the total row

            // Check if data exists and is not empty
            if (!data || data.length === 0) {
              console.log("No data available for plan details.");

              // Create and append "No data found" message
              const noDataRow = document.createElement('tr');
              const noDataCell = document.createElement('td');
              noDataCell.setAttribute('colspan', '13'); // Set the colspan to span all columns
              noDataCell.textContent = "No data found";
              noDataCell.style.textAlign = 'center';  // Center align the message
              noDataRow.appendChild(noDataCell);
              tableBody.appendChild(noDataRow);

              return; // Exit the function if no data
            }

            // Rest of the code to populate table with data (as you already have it)
            const hubloadHeaderRow = document.getElementById('hubloadHeaderRow');
            const totalPlanLoadedHeader = document.getElementById('totalPlanLoadedHeader');

            // Collect all unique hubload keys across all items in plandetaildata
            const uniqueHubloadKeys = [...new Set(this.plandetaildata.flatMap(item => item.hubload.map(hub => hub.key)))];

            // Dynamically generate hubload columns based on all unique keys
            uniqueHubloadKeys.forEach(key => {
              const th = document.createElement('th');
              th.textContent = key;
              hubloadHeaderRow.insertBefore(th, hubloadHeaderRow.querySelector('th:last-child'));
            });

            // Adjust the colspan of the "Total Plan Loaded" header
            totalPlanLoadedHeader.setAttribute('colspan', uniqueHubloadKeys.length + 1); // hubload columns + "Total" column

            data.forEach(item => {
              const row = document.createElement('tr');

              // Create cells for each column
              const originhubCell = document.createElement('td');
              originhubCell.textContent = item.hubname;
              row.appendChild(originhubCell);

              // Create cells for hubload dynamically under Total Plan Loaded
              uniqueHubloadKeys.forEach(key => {
                const hubCell = document.createElement('td');
                const hubData = item.hubload.find(hub => hub.key === key);
                hubCell.textContent = hubData ? hubData.value : '-'; // If no matching hubload key, show '-'
                row.appendChild(hubCell);
              });

              // Add Total column under "Total Plan Loaded"
              const totalCell = document.createElement('td');
              totalCell.textContent = item.total;
              row.appendChild(totalCell);

              // Other static columns
              const noofboxesCell = document.createElement('td');
              noofboxesCell.textContent = item.noofboxes;
              row.appendChild(noofboxesCell);

              const valweightCell = document.createElement('td');
              valweightCell.textContent = item.valweight;
              row.appendChild(valweightCell);

              const physicalweightCell = document.createElement('td');
              physicalweightCell.textContent = item.physicalweight;
              row.appendChild(physicalweightCell);

              const dispatchscanCell = document.createElement('td');
              dispatchscanCell.textContent = item.dispatchscan;
              row.appendChild(dispatchscanCell);

              const hubscanCell = document.createElement('td');
              hubscanCell.textContent = item.hubscan;
              row.appendChild(hubscanCell);

              const damageboxCell = document.createElement('td');
              damageboxCell.textContent = item.damagebox;
              row.appendChild(damageboxCell);

              const shortageCell = document.createElement('td');
              shortageCell.textContent = item.shortage;
              row.appendChild(shortageCell);

              const excessCell = document.createElement('td');
              excessCell.textContent = item.excess;
              row.appendChild(excessCell);

              const vreleasetimeCell = document.createElement('td');
              vreleasetimeCell.textContent = item.vreleasetime + ' hrs';
              row.appendChild(vreleasetimeCell);

              // Append row to table body
              tableBody.appendChild(row);
            });

            // Calculate total row as you already have it
            const totalRowData = {};
            totalRowData.noofboxes = 0;
            totalRowData.total = 0; // Total for the 'total' column

            // Initialize hubload totals for each unique key
            uniqueHubloadKeys.forEach(key => {
              totalRowData[key] = 0; // Initialize total for hubload
            });

            // Calculate totals
            data.forEach(item => {
              totalRowData.total += item.total; // Sum up total values
              totalRowData.noofboxes += item.noofboxes; // Sum up noofboxes

              // Sum up hubload values
              item.hubload.forEach(hub => {
                totalRowData[hub.key] = (totalRowData[hub.key] || 0) + hub.value;
              });
            });

            // Create the total row for total values
            const totalRowElement = document.createElement('tr');
            totalRowElement.classList.add('total-row');

            // Label for the total row
            const totalLabelCell = document.createElement('td');
            totalLabelCell.textContent = 'Total';
            totalRowElement.appendChild(totalLabelCell);

            // Append hubload total cells
            uniqueHubloadKeys.forEach(key => {
              const hubTotalCell = document.createElement('td');
              hubTotalCell.textContent = totalRowData[key] || '-'; // If no total, show '-'
              totalRowElement.appendChild(hubTotalCell);
            });

            // Add the total of 'total' column
            const totalTotalCell = document.createElement('td');
            totalTotalCell.textContent = totalRowData.total; // Total of total values
            totalRowElement.appendChild(totalTotalCell);

            // Add total for noofboxes to the same total row
            const totalNoOfBoxesCell = document.createElement('td');
            totalNoOfBoxesCell.textContent = totalRowData.noofboxes; // Total of noofboxes
            totalRowElement.appendChild(totalNoOfBoxesCell);

            // Leave other cells empty
            for (let i = 0; i < 8; i++) { // 8 is the number of static columns (Val Weight to V Release Time)
              const emptyCell = document.createElement('td');
              totalRowElement.appendChild(emptyCell);
            }

            // Append the total row to the table footer
            totalRow.appendChild(totalRowElement);
        },

        NationalLineHaulshowModal(plandata) {
          if (plandata) {
            this.editplanid = plandata.planid ? plandata.planid : ''
            if (this.editplanid) {
                let sendObj = {
                  planid:this.editplanid
                }
                //nlh plan detail api
                this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getLHPlanDetails`,sendObj).then((result) => {
                  if (result && result.body.returnvalue.plandetails) {
                  console.log("getLHPlanDetails @@@@@@", result)
                    this.lhplandetaildata = []
                    this.lhplandetaildata.push(result.body.returnvalue.plandetails)
                    this.lhhubloadunload = result.body.returnvalue.plandetails.hubloadunload
                    this.plandetaildata = result.body.returnvalue.plandetails ? result.body.returnvalue.plandetails.details : ''
                    this.getplandetaildata(this.plandetaildata);
                  } else {
                   this.lhplandetaildata = [];
                    this.lhhubloadunload =[];
                    this.getplandetaildata([]);
                    console.log("No plan details found----.");
                  }
                }).catch((ex) => {
                  console.log("error", ex);
                  Swal.fire({
                    title: 'Error',
                    text: 'An error occurred while fetching plan details.',
                    icon: 'error',
                    confirmButtonText: 'Close',
                  });
                });
              }
              this.$refs['NationalLineHaul-modal'].show();
          }
        },
        downloadAdhocFile(planid) {
          let sendObj = {
              planid: planid
            }
             this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/downloadPlancsv`, sendObj, { responseType: 'blob' })
        .then((response) => {
        console.log('downloadPlancsvdownloadPlancsvdownloadPlancsv',response.data.returnmsg);
        if(response.data.returnmsg && response.data.returnmsg=='UnSuccessful'){
          Swal.fire({
            title: 'Error',
            text: 'The file could not be downloaded. Please try again.',
            icon: 'error',
            confirmButtonText: 'Close',
          });
        }else{
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Plan-${planid}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                }
           
            }).catch((ex) => {
            
              console.log("error", ex);
              Swal.fire({
                title: 'Error',
                text: 'An error occurred while fetching plan details.',
                icon: 'error',
                confirmButtonText: 'Close',
              });
            });
        },
      viewPlanDetailsModal(planid,hideloadtime) {
          if (hideloadtime == 'hidehours') {
            this.hidetimeflag = true
          } else {
            this.hidetimeflag = false
          }
          let sendObj = {
            planid: planid
          }
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getPlanDetails`, sendObj).then((result) => {
            if (result && result.body.returnmsg == "Successful" && result.body.returnvalue.plandata.length) {
              this.ddplandetaildata = [];              
              this.totalrecords = result.body.returnvalue.plandata.length
              this.ddplandetaildata = result.body.returnvalue.plandata
              this.$refs['viewPlanDetails-modal'].show()
            }else{
             this.ddplandetaildata = [];            

              Swal.fire({
                title: 'Error',
                text: result.body.returnvalue || 'Plan not found. Please try again with a valid Plan ID.',
                icon: 'error',
                confirmButtonText: 'Close',
              });
            }
          }).catch((ex) => {
            console.log("error", ex);

            Swal.fire({
              title: 'Error',
              text: 'An error occurred while fetching plan details.',
              icon: 'error',
              confirmButtonText: 'Close',
            });
            
          });
        },
        redirectToEditPlan(planid) {
            window.open(`/ftl/newPlanUpload?planid=${planid}&editflag=true`, '_blank');     
        },
        formatHeader(header) {
          if (header.startsWith('arrivaldatetime')) {
            return header.replace(/^(arrivaldatetime)/, 'Destination Arrival Date-time');
          }
          if (header.startsWith('departuredatetime')) {
            return header.replace(/^(departuredatetime)/, 'Destination Departure Date-time');
          }
          if (header.startsWith('vehicleplacementdate')) {
            return header.replace(/^(vehicleplacementdate)/, 'Vehicle Placement Date');
          }
          if (header.startsWith('vehicleno')) {
            return header.replace(/^(vehicleno)/, 'Vehicle No');
          }
          if (header.startsWith('transportername')) {
            return header.replace(/^(transportername)/, 'Transporter Name');
          }
          if (header.startsWith('dispatchdatetime')) {
            return header.replace(/^(dispatchdatetime)/, 'Dispatch date-time');
          }
          return header.charAt(0).toUpperCase() + header.slice(1);
        },      
        getNationalHugLineDashboard: function () {
          this.loading = true; // Start loader
          const obj = {
            plantype: "nlh",
            nlhmodule: ["P2P", "north_to_south", "south_to_north"]
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllNLHPlan`, obj).then((result) => {
            if (result.body.returnmsg === "Successful") {
              const returnValue = result.body.returnvalue;
                // Assign the valid response to respective data properties
                  this.northToSouthData = returnValue.north_to_south || [];
                  this.southToNorthData = returnValue.south_to_north || [];
                  this.p2pData = returnValue.P2P || [];

                  this.totalRecordsP2P = this.p2pData.length;
                  this.totalRecordsNorthToSouth = this.northToSouthData.length;
                  this.totalRecordsSouthToNorth = this.southToNorthData.length;

                  this.loading = false;
                  
            console.log('---------getAllNLHPlan-----------', returnValue);
            } else {
              this.northToSouthData= [];
              this.southToNorthData= [];
              this.p2pData= [];
              this.totalRecordsP2P=0;
              this.totalRecordsNorthToSouth=0;
              this.totalRecordsSouthToNorth=0;
              this.loading = false;
            }
          }).catch((ex) => {
            console.log("error-----", ex);
            this.northToSouthData = [];
            this.southToNorthData = [];
            this.p2pData = [];
            this.totalRecordsP2P=0;
            this.totalRecordsNorthToSouth=0;
            this.totalRecordsSouthToNorth=0;
          }).finally(() => {
            this.loading = false; // Stop loader when request completes
          });;
        },        
        getviewPlanDetailsByPlanid(planId) {
          const requestData = { planId: planId };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getviewPlanDetailsByPlanid`, requestData)
          .then((response) => {
            if (response.body.returnmsg === "Successful" && response.body.returnvalue.length > 0) {
              this.planDetails = response.body.returnvalue;
              // Open the modal to show the details
            // this.showPlanDetailsModal();
              this.showPlanModal = true;
            } else {
              // If no records are found, show a SweetAlert
              this.planDetails = [];
              Swal.fire({
                title: 'Info',
                text: 'No records found for the selected Plan ID.',
                icon: 'info',
                confirmButtonText: 'OK',
              });
            }
        })
        .catch((error) => {
          console.error("Error fetching plan details: ", error);
          Swal.fire({
            title: 'Error',
            text: 'An error occurred while fetching plan details. Please try again.',
            icon: 'error',
            confirmButtonText: 'Close',
          });
        });
       },
          
        
        ConvertJsonToCsv(reportResult, reportName) {
          const json = reportResult
          const header = Object.keys(json[0])
          let csv = json.map(row => header.map(fieldName => JSON.stringify(row[fieldName] || '')))
          csv.unshift(header)
          csv = csv.join('\r\n')
          this.downloadCsv(csv, reportName)
        },
        downloadCsv(csv, reportName) {
          var csvData = csv
          const fileName = reportName
          var blob = new Blob([csvData], {
            type: 'application/csv;charset=utf-8;'
          })
          var link = document.createElement('a')
          var csvUrl = URL.createObjectURL(blob)
          link.href = csvUrl
          link.style = 'visibility:hidden'
          link.download = fileName + '.csv'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        },
        downloadPlan(moduleType, planId) {
          // Logic to download the plan using moduleType and planId
          console.log(`Downloading Plan: Module Type = ${moduleType}, Plan ID = ${planId}`);
          // Implement your download logic here (e.g., API call)
        }
    },
};
</script>

<style>
.collapsible-header {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-container {
  overflow-y: auto;
  max-height: 400px; /* Adjust height for vertical scrolling */
}

.details-table-container {
  overflow-x: auto;
  max-height: 300px; /* Limit the height for better scrollability */
}

/* Optional: Fixed header for table */
.table thead th {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
}

/* Optional: Fixed header for nested tables */
.details-table thead th {
  position: sticky;
  top: 0;
  z-index: 9;
  background: #f8f9fa;
}
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.modal-backdrop {
  position: absolute !important;
  }


.north-to-south {
  background-color: #f0f8ff; /* Light blue */
}

.south-to-north {
  background-color: #fffaf0; /* Light cream */
}

.p2p {
  background-color: #f5f5dc; /* Beige */
}

.details-table {
  width: 100%;
  border-collapse: collapse; /* Ensures borders are combined */
}

.details-table th,
.details-table td {
  border: 1px solid #ddd; /* Broader borders for table cells */
  //padding: 12px; /* Increased padding for more space */
  text-align: left; /* Left align text for readability */
}

.details-table th {
  background-color: #f2f2f2; /* Light gray background for headers */
  font-weight: bold; /* Bold text for headers */
}

.details-table tr:hover {
  background-color: #f9f9f9; /* Light gray hover effect for rows */
}

.b-card {
  margin-bottom: 20px; /* Space between cards */
  border-radius: 8px; /* Rounded corners for cards */
}
.plan-id {
  margin-top: 5px; /* Space between the button and Plan ID */
  font-size: 0.85em; /* Slightly smaller font size */
  color: #6c757d; /* Bootstrap's text-muted color */
  text-align: center; /* Center align the text */
}


</style>
